import { Brands } from 'lib/themes';

export const ALL_SITE_NAMES = [
  'WhiteLabel',
  'BettyCrocker',
  'Pillsbury',
  'BTFE',
  'GeneralMills',
  'HaagenDazs',
  'OEP',
  'Cheerios',
  'Annies',
  'GMFS',
  'BLUE',
  'CTC',
  'Nature Valley',
  'LuckyCharms',
  'Progresso',
  'CareersGlobal',
  'Autumns Gold',
  'Bell Institute',
  'Bugles',
  'Cascadian Farm',
  'Chex Mix',
  'Dunkaroos',
  'Fiber One',
  'Fruit Roll Ups',
  'Fruit by the Foot',
  'Gardettos',
  'GoldMedal',
  'Gushers',
  'Larabar',
  'MLK Breakfast',
  'Morning Summit',
  'PizzaPops',
  'Sujata Foods',
  'Totinos',
] as const;
export type SiteName = (typeof ALL_SITE_NAMES)[number];

export const BRAND_MAPPING: Record<Brands, SiteName[]> = {
  BrandsAnnies: ['Annies'],
  BrandsWhiteLabel: ['WhiteLabel'],
  BrandsBettyCrocker: ['BettyCrocker'],
  BrandsPillsbury: ['Pillsbury'],
  BrandsBTFE: ['BTFE'],
  BrandsGMI: ['GeneralMills', 'CareersGlobal'],
  BrandsGMFS: ['GMFS'],
  BrandsHD: ['HaagenDazs'],
  BrandsOEP: ['OEP'],
  BrandsCheerios: ['Cheerios'],
  BrandsBLUE: ['BLUE'],
  BrandsCTC: ['CTC'],
  BrandsNatureValley: ['Nature Valley'],
  BrandsLuckyCharms: ['LuckyCharms'],
  BrandsProgresso: ['Progresso'],
  BrandsAutumnsGold: ['Autumns Gold'],
  BrandsBellInstitute: ['Bell Institute'],
  BrandsBugles: ['Bugles'],
  BrandsCascadianFarm: ['Cascadian Farm'],
  BrandsChexMix: ['Chex Mix'],
  BrandsDunkaroos: ['Dunkaroos'],
  BrandsFiberOne: ['Fiber One'],
  BrandsFruitRollUps: ['Fruit Roll Ups'],
  BrandsFruitbytheFoot: ['Fruit by the Foot'],
  BrandsGardettos: ['Gardettos'],
  BrandsGoldMedal: ['GoldMedal'],
  BrandsGushers: ['Gushers'],
  BrandsLarabar: ['Larabar'],
  BrandsMLKBreakfast: ['MLK Breakfast'],
  BrandsMorningSummit: ['Morning Summit'],
  BrandsPizzaPops: ['PizzaPops'],
  BrandsSujataFoods: ['Sujata Foods'],
  BrandsTotinos: ['Totinos'],
};
